// extracted by mini-css-extract-plugin
module.exports = {"xBox":"styles_xBox__3GoOu","x":"styles_x__30TPQ"};